"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _order = require("@/api/order");
var _auth = require("@/utils/auth");
var _orderDetails = _interopRequireDefault(require("./orderDetails.vue"));
var _createOrder = _interopRequireDefault(require("./createOrder.vue"));
var _orderResult = _interopRequireDefault(require("./orderResult.vue"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports.default = {
  components: {
    orderDetails: _orderDetails.default,
    createOrder: _createOrder.default,
    orderResult: _orderResult.default
  },
  data: function data() {
    return {
      missOrderCount: 0,
      // 未接单数量
      dialogVisibleImg: false,
      dialogVisibleImgUrl: "",
      detailEndStatus: false,
      //  处理结果 完成工单
      detailRedeployGoStatus: false,
      // 继续分配
      detailRedeployStatus: false,
      // 处理结果 转派工单
      detailEditStatus: false,
      // 处理结果 编辑状态
      editStatus: false,
      // 工单编辑状态
      workOrderIds: 0,
      // 工单 id
      loading: false,
      showDetail: false,
      // createNew: false,
      activeName: "review",
      tableData: [],
      filterItem: {
        entryName: "",
        workOrderType: "",
        workOrderStatus: "",
        page: 1,
        rows: 10,
        total: 0,
        filterTime: []
      },
      column: [{
        type: "index",
        label: "序号",
        width: "100"
      }, {
        prop: "entryName",
        label: "项目名称",
        minWidth: "120"
      }, {
        prop: "workOrderTypeName",
        label: "工单类型",
        minWidth: "120",
        slot: true
      }, {
        prop: "submitterName",
        label: "提交人",
        minWidth: "120"
      }, {
        prop: "workOrderStatusName",
        label: "工单状态",
        minWidth: "120",
        slot: true
      }, {
        prop: "handlerTypeName",
        label: "处理情况",
        minWidth: "120",
        slot: true
      }, {
        prop: "createTime",
        label: "工单提交时间",
        minWidth: "120"
      }, {
        prop: "workOrderDate",
        label: "最后更新时间",
        minWidth: "120"
      }],
      workOrderStatus: {
        0: "未处理",
        1: "处理中",
        2: "已关闭"
      },
      handlerType: {
        1: "待我处理",
        2: "我处理中",
        3: "处理完成"
      },
      editForm: {
        detail: "",
        imgUrl: [],
        imgUrlName: []
      },
      projectUserList: [],
      // 项目关联用户  处理人
      projectSendUserList: [],
      // 项目关联用户 抄送人
      lastOrderData: {},
      // 处理信息 最有一条
      checkOrder: {},
      // 选中工单
      checkOrderDetail: {},
      // 选中工单处理信息
      // 转派
      detailRedeployForm: {
        handleId: "",
        sendUserIds: [],
        detail: "",
        files: [],
        imgUrlName: []
      },
      detailRedeployFormRules: {
        handleId: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }],
        sendUserIds: [{
          required: true,
          message: "请选择",
          trigger: "change"
        }]
      }
    };
  },
  computed: {
    // 工单详情步骤
    orderDetailsStatus: function orderDetailsStatus() {
      return !!(this.detailEndStatus || this.detailRedeployStatus || this.detailEditStatus || this.detailRedeployGoStatus);
    },
    userId: function userId() {
      return (0, _auth.getUserId)();
    }
  },
  created: function created() {
    this.getData();
    this.handleMissOrder();
  },
  methods: {
    resetForm: function resetForm() {
      this.filterItem = {
        entryName: "",
        workOrderType: "",
        workOrderStatus: "",
        page: 1,
        rows: 10,
        total: 0,
        filterTime: []
      };
      this.getData();
      this.handleMissOrder();
    },
    handleMissOrder: function handleMissOrder() {
      var _this = this;
      var startDate = "";
      var endDate = "";
      if (this.filterItem.filterTime != null) {
        if (this.filterItem.filterTime.length > 1) {
          startDate = this.filterItem.filterTime[0];
          endDate = this.filterItem.filterTime[1];
        }
      }
      var parmers = {
        entryName: this.filterItem.entryName,
        page: "",
        rows: "",
        workOrderStatus: this.filterItem.workOrderStatus,
        workOrderType: this.filterItem.workOrderType,
        startDate: startDate,
        endDate: endDate
      };
      (0, _order.getProjectWorkOrderListByReviewerId)(parmers).then(function (res) {
        var count = 0;
        if (res) {
          res.rows.forEach(function (item) {
            if (item.handlerType == 1) count++;
          });
        }
        _this.missOrderCount = count;
      });
    },
    // 点击了预览图片
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogVisibleImgUrl = file.url;
      this.dialogVisibleImg = true;
    },
    imageUpload: function () {
      var _imageUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(file, fileList) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.detailRedeployForm.files = fileList.map(function (item) {
                return item.raw;
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function imageUpload(_x, _x2) {
        return _imageUpload.apply(this, arguments);
      }
      return imageUpload;
    }(),
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 10MB!",
          type: "warning"
        });
      }
      return isLt2M;
    },
    handleExceed: function handleExceed(file, flies) {
      this.$message.warning("最多只能上传10张");
    },
    // 接单
    handleOrderAdd: function handleOrderAdd() {
      var _this2 = this;
      (0, _order.postOrderAdd)({
        projectWorkOrderHandlerId: this.lastOrderData.id
      }).then(function (res) {
        _this2.$message.success("接单成功");
        _this2.showDetail = false;
        _this2.getData();
      });
    },
    // 获取项目关联的用户列表
    getProjectUserList: function getProjectUserList() {
      var _this3 = this;
      this.detailRedeployForm = {
        handleId: "",
        sendUserIds: [],
        detail: "",
        files: [],
        imgUrlName: []
      }, (0, _order.getuserInfoByProjectId)({
        projectId: this.checkOrder.projectId
      }).then(function (res) {
        _this3.projectUserList = res.filter(function (item) {
          return item.id != _this3.userId;
        });
        _this3.projectSendUserList = _this3.projectUserList.map(function (item) {
          item.disabled = false;
          _this3.lastOrderData.projectWorkOrderSendUsersSelectDTOList.map(function (i) {
            if (item.id == i.sendUserId) item.disabled = true;
          });
          return item;
        });
      });
    },
    // 处理完成关闭
    handleDetailClose: function () {
      var _handleDetailClose = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this4 = this;
        var i, file, data;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.detailRedeployForm.files.length)) {
                _context2.next = 8;
                break;
              }
              file = this.detailRedeployForm.files[i];
              _context2.next = 5;
              return this.uploadImage(file, "detailRedeployForm");
            case 5:
              i++;
              _context2.next = 1;
              break;
            case 8:
              data = {
                id: this.lastOrderData.id,
                handlerEventDescription: this.detailRedeployForm.detail,
                orderReceivingHandlerType: 0,
                multipartFiles: this.detailRedeployForm.imgUrlName
              };
              (0, _order.postReceivedOrderHandler)(data).then(function (res) {
                _this4.handleCloseModel();
              });
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleDetailClose() {
        return _handleDetailClose.apply(this, arguments);
      }
      return handleDetailClose;
    }(),
    // 继续分配
    handleDetailRedeployGo: function () {
      var _handleDetailRedeployGo = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this5 = this;
        var i, file, data;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs["detailRedeployForm"].validate(function (valid) {
                if (!valid) {
                  return;
                }
              });
              i = 0;
            case 2:
              if (!(i < this.detailRedeployForm.files.length)) {
                _context3.next = 9;
                break;
              }
              file = this.detailRedeployForm.files[i];
              _context3.next = 6;
              return this.uploadImage(file, "detailRedeployForm");
            case 6:
              i++;
              _context3.next = 2;
              break;
            case 9:
              data = {
                id: this.lastOrderData.id,
                handlerEventDescription: this.detailRedeployForm.detail,
                sonHandlerId: this.detailRedeployForm.handleId,
                orderReceivingHandlerType: 1,
                workOrderSendUsers: this.detailRedeployForm.sendUserIds,
                multipartFiles: this.detailRedeployForm.imgUrlName
              };
              (0, _order.postReceivedOrderHandler)(data).then(function (res) {
                _this5.handleCloseModel();
              });
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function handleDetailRedeployGo() {
        return _handleDetailRedeployGo.apply(this, arguments);
      }
      return handleDetailRedeployGo;
    }(),
    // 转派
    handleDetailRedeploy: function handleDetailRedeploy() {
      var _this6 = this;
      this.$refs["detailRedeployForm"].validate(function (valid) {
        if (!valid) {
          return;
        }
      });
      var data = {
        id: this.lastOrderData.id,
        handlerEventDescription: this.detailRedeployForm.detail,
        sonHandlerId: this.detailRedeployForm.handleId,
        workOrderSendUsers: this.detailRedeployForm.sendUserIds
      };
      (0, _order.postUnOrderReceivingReassignment)(data).then(function (res) {
        _this6.handleCloseModel();
      });
    },
    // 直接关闭
    handleClose: function handleClose() {
      var _this7 = this;
      (0, _order.postOrderClose)({
        projectWorkOrderHandlerId: this.lastOrderData.id
      }).then(function (res) {
        _this7.handleCloseModel();
      });
    },
    handleCloseModel: function handleCloseModel() {
      this.$message.success("操作成功");
      this.showDetail = false;
      this.getData();
    },
    handleLastOrderData: function handleLastOrderData(e) {
      this.lastOrderData = e;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(file) {
        var _this8 = this;
        var key,
          tmp,
          _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              key = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : "editForm";
              tmp = new FormData();
              tmp.append("multipartFile", file);
              _context4.next = 5;
              return (0, _order.postUploadImage)(tmp).then(function (res) {
                if (res) {
                  _this8[key]["imgUrlName"].push(res);
                }
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function uploadImage(_x3) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    handleUpload: function handleUpload(e, list) {
      this.editForm.imgUrl = list;
    },
    handleShowEdit: function handleShowEdit(e) {
      var _this9 = this;
      this.$nextTick(function () {
        _this9.detailEditStatus = true;
        _this9.checkOrderDetail = e;
      });
    },
    // 编辑
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5(type) {
        var _this10 = this;
        var i, file, data, _data;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.editForm.imgUrl.length)) {
                _context5.next = 8;
                break;
              }
              file = this.editForm.imgUrl[i].raw;
              _context5.next = 5;
              return this.uploadImage(file);
            case 5:
              i++;
              _context5.next = 1;
              break;
            case 8:
              if (type == "order") {
                data = {
                  submitterId: (0, _auth.getUserId)(),
                  workOrderSendUsers: [],
                  id: this.checkOrder.id,
                  projectId: this.checkOrder.projectId,
                  reviewerId: this.checkOrder.reviewerId,
                  workOrderStatus: this.checkOrder.workOrderStatus,
                  workOrderType: this.checkOrder.workOrderType,
                  eventDescription: this.editForm.detail,
                  multipartFiles: this.editForm.imgUrlName
                };
                data.workOrderSendUsers = this.checkOrder.projectWorkOrderSendUsersSelectDTOList.map(function (item) {
                  return item.sendUserId;
                });
                (0, _order.postOrderEdit)(data).then(function (res) {
                  _this10.editStatus = false;
                  _this10.getData();
                  _this10.$message.success("编辑成功");
                });
              } else {
                _data = {
                  id: this.checkOrderDetail.id,
                  handlerEventDescription: this.editForm.detail,
                  multipartFiles: this.editForm.imgUrlName
                };
                _data.workOrderSendUsers = this.checkOrderDetail.projectWorkOrderSendUsersSelectDTOList.map(function (item) {
                  return item.sendUserId;
                });
                (0, _order.postOrderDetailEdit)(_data).then(function (res) {
                  _this10.detailEditStatus = false;
                  _this10.$refs.orderDetails.init();
                  _this10.$message.success("编辑成功");
                });
              }
            case 9:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleEdit(_x4) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    //点击了切换名称
    handleActiveName: function handleActiveName(e) {
      this.activeName = e;
      this.getData();
    },
    //点击了详情
    handleDetail: function handleDetail(status) {
      this.showDetail = status;
    },
    //创建工单按钮
    createOrderAction: function createOrderAction() {
      // this.createNew = true;
      var url = this.$router.resolve({
        name: "OrderAdd"
      });
      window.open(url.href, "_blank");
    },
    //创建工单变为了隐藏
    // handleCreateHidden(change) {
    //   this.createNew = false;
    //   if (change) {
    //     // 发生了变化，重新请求数据
    //     this.filterItem.page = 1;
    //     this.getData();
    //   }
    // },
    //获取数据 异步
    getData: function () {
      var _getData = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee6() {
        var _this11 = this;
        var request, startDate, endDate, parmers;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.loading = true;
              request = null;
              startDate = "";
              endDate = "";
              if (this.filterItem.filterTime != null) {
                if (this.filterItem.filterTime.length > 1) {
                  startDate = this.filterItem.filterTime[0];
                  endDate = this.filterItem.filterTime[1];
                }
              }
              parmers = {
                entryName: this.filterItem.entryName,
                page: this.filterItem.page,
                rows: this.filterItem.rows,
                workOrderStatus: this.filterItem.workOrderStatus,
                workOrderType: this.filterItem.workOrderType,
                startDate: startDate,
                endDate: endDate
              };
              _context6.t0 = this.activeName;
              _context6.next = _context6.t0 === "submit" ? 9 : _context6.t0 === "review" ? 11 : _context6.t0 === "send" ? 13 : 15;
              break;
            case 9:
              request = (0, _order.getProjectWorkOrderListBySubmitterId)(parmers);
              return _context6.abrupt("break", 16);
            case 11:
              request = (0, _order.getProjectWorkOrderListByReviewerId)(parmers);
              return _context6.abrupt("break", 16);
            case 13:
              request = (0, _order.getProjectWorkOrderSendUsersBySendUserId)(parmers);
              return _context6.abrupt("break", 16);
            case 15:
              return _context6.abrupt("break", 16);
            case 16:
              request.then(function (res) {
                if (res) {
                  var rows = res["rows"];
                  _this11.filterItem.total = res["total"];
                  _this11.tableData = rows.map(function (item) {
                    item.workOrderStatusName = _this11.workOrderStatus[item.workOrderStatus];
                    item.workOrderTypeName = item.workOrderType === 1 ? "设备故障" : "其他";
                    if (item.handlerType != null) {
                      item.handlerTypeName = _this11.handlerType[item.handlerType];
                    }
                    return item;
                  });
                }
                _this11.loading = false;
              });
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }(),
    //点击了查询
    onSubmit: function onSubmit() {
      this.filterItem.page = 1;
      this.getData();
      this.handleMissOrder();
    },
    // 返回单元格的样式
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      var style = "";
      if (columnIndex === 4) {
        var status = this.tableData[rowIndex].workOrderStatus;
        switch (status) {
          case 0:
            style = "undealLabel";
            break;
          case 1:
            style = "dealingLabel";
            break;
          case 2:
            style = "finishLabel";
            break;
          default:
            break;
        }
      }
      if (this.activeName === "review" && columnIndex === 5) {
        var handle = this.tableData[rowIndex].handlerType;
        switch (handle) {
          case 1:
            style = "handle1Label";
            break;
          case 2:
            style = "handle2Label";
            break;
          case 3:
            style = "handle3Label";
            break;
          default:
            break;
        }
      }
      return style;
    },
    // 当前页码发生了变化
    handleCurrentPageChange: function handleCurrentPageChange(page) {
      this.filterItem.page = page;
      this.getData();
    },
    // 点击了删除
    handleDelete: function handleDelete(row) {
      sessionStorage.setItem("projectId", row.id);
      this.$store.dispatch("app/getProjectId", row.id);
      // this.$store.dispatch('app/getType', this.type)
      if (JSON.parse(sessionStorage.getItem("projectData"))) {
        var arr = JSON.parse(sessionStorage.getItem("projectData"));
        this.$router.push({
          path: "/" + arr[0].path
        });
      }
    },
    //点击了查看
    handleInfo: function handleInfo(row) {
      var _this12 = this;
      //console.log("查看", row);
      this.handleInitInfo();
      this.checkOrder = _objectSpread({}, row);
      this.workOrderIds = row.id;
      this.handleDetail(true);
      this.$nextTick(function () {
        _this12.showDetail = true;
      });
      this.$forceUpdate(function () {
        _this12.$refs.orderDetails.init();
      });
      // getProjectWorkOrderHandlerByWorkOrderId({workOrderId:row.id}).then(res=>{
      //   this.projectList = res.rows
      // })
    },
    handleInitInfo: function handleInitInfo() {
      this.detailEndStatus = false; //  处理结果 完成工单
      this.detailRedeployGoStatus = false; // 继续分配
      this.detailRedeployStatus = false; // 处理结果 转派工单
      this.detailEditStatus = false; // 处理结果 编辑状态
    },
    handleEditInfo: function handleEditInfo(row) {
      this.editStatus = true;
      this.checkOrder = _objectSpread({}, row);
      this.editForm = {
        detail: "",
        imgUrl: [],
        imgUrlName: []
      };
    },
    handleCloseDialog: function handleCloseDialog(done) {
      this.$confirm("确认关闭？").then(function (_) {
        done();
      }).catch(function (_) {});
    }
  }
};